/**
 * 将毫秒时间格式化
 * 字符串格式参数如下:
 * 小时:
 * 		h:		1, 2, 3....
 * 		hh:		01, 02, 03....
 * 分:
 * 		m:		0, 1, 2...., 59
 * 		mm:		00, 01, 02...., 59
 * 秒:
 * 		s:		0, 1, 2...., 59
 * 		ss:		00, 01, 02...., 59
 * @param value 起点时间, 能转换成Date对象的数字, 字符串或者Date对象
 * @example $timestamp(37100000) => '10:18:20'
 * @example $timestamp(37100000, "mm:ss") => '18:20'
 */
export default function (value: number, formatStr: string = 'hh:mm:ss'){
	const timestamp: number = Math.round((+value || 0) / 1000);
	const hours: number = Math.floor(timestamp / 3600);
	const minutes: number = Math.floor((timestamp % 3600) / 60);
	const seconds: number = Math.floor(timestamp % 60);
	return formatStr
		.replace(/hh/g, hours > 9 ? '' + hours : '0' + hours)
		.replace(/h/g, '' + hours)
		.replace(/mm/g, minutes > 9 ? '' + minutes : '0' + minutes)
		.replace(/m/g, '' + minutes)
		.replace(/ss/g, seconds > 9 ? '' + seconds : '0' + seconds)
		.replace(/s/g, '' + seconds);
}
